import { BarElement, Chart, LineController } from 'chart.js';
import React from 'react';
import { Bar } from 'react-chartjs-2';
import { kFormatter, percentFormatter } from 'utils';

Chart.register(BarElement, LineController);
const labels = [
    'Feb 2',
    'Feb 4',
    'Feb 6',
    'Feb 8',
    'Feb 10',
    'Feb 12',
    'Feb 14',
    'Feb 16',
    'Feb 18',
    'Feb 20',
    'Feb 22',

    'Feb 24',
    'Feb 28',

    'March 2',
    'March 4',
    'March 6',
    'March 8',
    'March 10',
    'March 12',
    'March 14',
    'March 16',
    'March 18',
    'March 20',
    'March 22',

    'March 2',
    'March 4',
    'March 6',
    'March 8',
    'March 10',
    'March 12',
    'March 14',
    'March 16',
    'March 18',
    'March 20',
    'March 22',

    'March 24',
    'March 26',
    'March 20',
    'March 22',

    'March 24',
    'March 26',

    'March 28',
    'March 28',
    'March 30',
    'Apr 3',
];

const dataRandom = labels.map((item) => Math.floor(Math.random() * 1500) + 1500);
const dataRandom2 = labels.map((item) => Math.floor(Math.random() * 100) + 100);
const dataRandomCtr = labels.map((item) => Math.random() * 1);

const data = {
    datasets: [
        {
            type: 'line',
            fill: false,
            lineTension: 0.4,
            backgroundColor: '#0E65F1',
            borderWidth: 2,
            borderColor: '#0E65F1',
            pointRadius: 0,
            data: dataRandom,
            yAxisID: 'impression_click',
        },
        {
            type: 'line',
            fill: false,
            lineTension: 0.4,
            borderWidth: 2,

            backgroundColor: 'rgba(14, 101, 241, .25)',
            zIndex: 1,
            borderColor: 'rgba(14, 101, 241, .25)',
            pointRadius: 0,
            data: dataRandom2,
            yAxisID: 'impression_click',
        },
        {
            type: 'bar',
            label: 'Bar Dataset',
            data: dataRandomCtr,
            backgroundColor: 'rgba(14, 101, 241, .35)',
            hoverBackgroundColor: '#0E65F1',
            zIndex: 0,
            order: 3,
            yAxisID: 'ctr',
        },
    ],
    labels: labels,
};

const options = {
    maintainAspectRatio: false,
    scales: {
        ctr: {
            position: 'right',
            beginAtZero: true,
            type: 'linear',

            grid: {
                display: false,
            },
            ticks: {
                callback: function (value, index, ticks) {
                    return percentFormatter(value);
                },
                stepSize: 0.5,
                font: {
                    size: 10,
                    color: '#f3f3f3',
                },
                padding: 0,

                color: '#1D2533',
            },
        },
        impression_click: {
            position: 'left',
            beginAtZero: true,
            type: 'linear',
            grid: {
                display: false,
            },
            suggestedMin: 0,
            suggestedMax: 5000,
            ticks: {
                callback: function (value, index, ticks) {
                    return kFormatter(value);
                },
                stepSize: 2500,
                font: {
                    size: 10,
                },
                color: '#1D2533',
                padding: 0,
            },
        },

        x: {
            grid: {
                display: false,
            },
            ticks: {
                autoSkip: true,
                maxTicksLimit: 20,
                stepSize: 0.2,
                font: {
                    size: 10,
                },
                minRotation: 45,
                color: '#1D2533',
            },
        },
    },
};

function BarLineChart() {
    return <Bar data={data} options={options} />;
}

export default BarLineChart;
